import gql from 'graphql-tag';

export const USER_FIELDS = gql`
  fragment UserFields on ri_apps_prd_users {
    user_id
    email
    phone
    # status
    first_name
    last_name
    # role
    address
    address2
    city
    state
    zip
    users_statuses {
      status_id
      name
      code
    }
    users_user_roles {
      user_roles_roles {
        role_id
        name
        code
      }
    }
    users_user_organizations {
      flg_inactive
      user_organization_id
      user_organizations_organization {
        organization_id
        name
      }
      user_organizations_role {
        role_id
        name
        code
      }
    }
    users_user_groups {
      user_group_id
      user_groups_group {
        group_id
        organization_id
        name
      }
    }
  }
`;

export const USER_BASIC_FIELDS = gql`
  fragment UserBasicFields on ri_apps_prd_users {
    user_id
    email
    phone
    # status
    first_name
    last_name
    # role
    address
    address2
    city
    state
    zip
    users_statuses {
      status_id
      name
      code
    }
    users_user_roles {
      user_roles_roles {
        role_id
        name
        code
      }
    }
    users_user_groups {
      user_group_id
      user_groups_group {
        organization_id
        group_id
        name
      }
    }
  }
`;

export const GET_USER_BY_SUB = gql`
  query getUserBySub($sub: String!) {
    rows: ri_apps_prd_users(where: { cognito_sub: { _eq: $sub } }) {
      ...UserFields
      users_module_permissions(
        where: { user_module_permissions_app_module: { platform: { _eq: "web" } } }
      ) {
        permission_id
        organization_id
        user_module_permissions_app_module {
          module_id
          module
          needs_permission
          platform
        }
      }
    }
  }
  ${USER_FIELDS}
`;

export const GET_USER_BY_ID = gql`
  query getUserById($user_id: Int!) {
    row: ri_apps_prd_users_by_pk(user_id: $user_id) {
      ...UserFields
      users_module_permissions(
        where: { user_module_permissions_app_module: { platform: { _eq: "web" } } }
      ) {
        permission_id
        organization_id
        user_module_permissions_app_module {
          module_id
          module
          needs_permission
          platform
        }
      }
    }
  }
  ${USER_FIELDS}
`;

export const GET_USERS = gql`
  query getUsers($filter: ri_apps_prd_users_bool_exp) {
    rows: ri_apps_prd_users(where: $filter) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const GET_ALL_USERS = gql`
  query getUsers($filter: ri_apps_prd_users_bool_exp = {}) {
    rows: ri_apps_prd_users(
      where: {
        _and: [
          $filter
          { flg_inactive: { _eq: "N" }, users_user_organizations: { flg_inactive: { _eq: "N" } } }
        ]
      }
    ) {
      ...UserBasicFields
      users_user_organizations(where: { flg_inactive: { _eq: "N" } }) {
        user_organization_id
        created_at
        source
        user_organizations_organization {
          organization_id
          name
        }
        user_organizations_role {
          role_id
          name
          code
        }
      }
    }
  }
  ${USER_BASIC_FIELDS}
`;

export const GET_ORG_USERS = gql`
  query GetOrgUsers($org_id: Int!) {
    rows: ri_apps_prd_organizations_by_pk(organization_id: $org_id) {
      organization_id
      name

      organizations_user_organizations {
        user_organization_id
        user_id
        organization_id

        user_organizations_role {
          role_id
          name
          code
        }

        user_organizations_user {
          ...UserFields
        }
      }
    }
  }
  ${USER_FIELDS}
`;

export const GET_ORG_ADMINS = gql`
  query GetOrgUsers($org_id: Int!) {
    rows: ri_apps_prd_organizations_by_pk(organization_id: $org_id) {
      organization_id
      name

      organizations_user_organizations(where: { role_id: { _eq: 2 } }) {
        user_organization_id
        user_id
        organization_id

        user_organizations_role {
          role_id
          name
          code
        }

        user_organizations_user {
          ...UserFields
        }
      }
    }
  }
  ${USER_FIELDS}
`;

export const GET_CAMPAIGN_USERS = gql`
  query GetCampaignUsers($campaign_id: Int!) {
    rows: ri_apps_prd_user_campaigns(where: { campaign_id: { _eq: $campaign_id } }) {
      user_campaign_id
      user_id
      campaign_id
      user_organization_id

      user_campaigns_user_organizations {
        user_organization_id
        user_id
        organization_id

        user_organizations_role {
          role_id
          name
          code
        }
      }
      user_campaigns_user {
        ...UserFields
      }
    }
  }
  ${USER_FIELDS}
`;

export const GET_ORG_OWNERS = gql`
  query GetOrgOwners($campaign_id: Int!) {
    ri_apps_prd_campaigns(where: { campaign_id: { _eq: $campaign_id } }) {
      campaign_id
      name
      organization_id
      campaigns_organization {
        organization_id
        organizations_user_organizations {
          flg_inactive
          user_organizations_user {
            ...UserFields
          }
        }
      }
    }
  }
  ${USER_FIELDS}
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($user_id: Int!, $data: ri_apps_prd_users_set_input!) {
    update_ri_apps_prd_users_by_pk(pk_columns: { user_id: $user_id }, _set: $data) {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

export const UPDATE_USER_ROLE = gql`
  mutation updateUserRole($user_id: Int!, $role_id: Int!) {
    update_ri_apps_prd_user_roles(
      _set: { role_id: $role_id }
      where: { user_id: { _eq: $user_id } }
    ) {
      affected_rows
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($user_id: Int!) {
    delete_ri_apps_prd_users_by_pk(user_id: $user_id) {
      user_id
    }
  }
`;

export const CHECK_USER_EXISTENCE = gql`
  query GET_USER($email: String!) {
    ri_apps_prd_users(where: { email: { _ilike: $email } }) {
      user_id
    }
  }
`;

export const GET_USERS_BY_TASK_RESULTS = gql`
  query getUsersByTask($task_id: Int!) {
    rows: ri_apps_prd_users(
      where: { users_t_results: { t_results_task_results: { task_id: { _eq: $task_id } } } }
    ) {
      user_id
      first_name
      last_name
    }
  }
`;

export const GET_ALL_USERS_FOR_ORG = gql`
  query GetAllUsersForOrg($organization_id: Int!) {
    rows: ri_apps_prd_user_organizations(where: { organization_id: { _eq: $organization_id }, flg_inactive: {
      _eq: "N"
    } }) {
      user_organization_id
      user_id
      user_organizations_user {
        ...UserFields
      }
    }
  }
  ${USER_FIELDS}
`;

export const DEACTIVATE_USER = gql`
  mutation deActivateUser($user_id: Int!, $org_ids: [Int!]!) {
    row: update_ri_apps_prd_user_organizations(
      where: { organization_id: { _in: $org_ids }, user_id: { _eq: $user_id } }
      _set: { flg_inactive: "Y" }
    ) {
      affected_rows
    }
  }
`;

export const GET_USER_TASKS = gql`
  query GetUserTasks($user_id: Int!) {
    rows: ri_apps_prd_user_tasks(where: { user_id: { _eq: $user_id } }) {
      user_id
      user_tasks_task {
        task_id
        name
      }
    }
  }
`;

export const GET_USER_TASKS_FOR_ORGANIZATION = gql`
  query GetUserTasksForOrganization($user_id: Int!, $org_id: Int!) {
    rows: ri_apps_prd_user_tasks(
      where: {
        user_id: { _eq: $user_id }
        user_tasks_task: {
          tasks_task_campaigns: { task_campaigns_campaign: { organization_id: { _eq: $org_id } } }
          _or: [{ is_archived: { _eq: false } }, { is_archived: { _is_null: true } }]
        }
      }
    ) {
      user_id
      user_tasks_task {
        task_id
        name
      }
    }
  }
`;

export const GET_USER_ORGANIZATION_ROLE = gql`
  query GetUserOrganization($user_id: Int!, $org_id: Int!) {
    rows: ri_apps_prd_user_organizations(
      where: { user_id: { _eq: $user_id }, organization_id: { _eq: $org_id } }
    ) {
      role_id
      user_organizations_role {
        code
      }
    }
  }
`;

// Removed: UPDATE_USER_ORGANIZATION_ROLE. It set role_id on every user_organizations row for a
// user (no organization filter), which is org-role dominance run backwards — one org's decision
// rewriting the user's standing in all the others. Its only caller was the uplift dialog in
// organizations-create.js. Use UPDATE_ORG_USER (organizations/queries.js) to change one
// membership.

export const GET_ORG_USER_NOTES = gql`
  query GetOrgUserNotes($where: ri_apps_prd_org_user_notes_bool_exp) {
    rows: ri_apps_prd_org_user_notes(where: $where) {
      org_user_note_id
      organization_id
      user_id
      notes
      org_user_notes_last_updated_by {
        user_id
        email
        first_name
        last_name
      }
      created_at
      updated_at
    }
  }
`;

export const UPSERT_ORG_USER_NOTE = gql`
  mutation UpsertOrgUserNote($user_id: Int!, $org_id: Int!, $notes: String!) {
    insert_ri_apps_prd_org_user_notes_one(
      object: { user_id: $user_id, organization_id: $org_id, notes: $notes }
      on_conflict: {
        constraint: org_user_notes_organization_id_user_id_key
        update_columns: [notes]
      }
    ) {
      org_user_note_id
    }
  }
`;
